import React, { Component } from 'react'
import AssemblyChoiceEditForm from './choice.component.jsx'
import {FormattedMessage} from 'react-intl'
import CalculatorFormulaForm from '../calculator/formula.component.jsx'

class AssemblyPartEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: this.props.part.id,
            type: this.props.part.type,
            name: this.props.part.name,
            required: this.props.part.required,
            sequence: this.props.part.sequence,
            choices: this.props.part.choices,
            formula: this.props.formula,
            terms: this.props.terms || [],
            hasCalculator: this.props.hasCalculator || false,
        }
        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.onDelete = this.props.onDelete || defaultCallback
        this.onNewChoice = this.props.onNewChoice || defaultCallback
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deletePart = this.deletePart.bind(this)
        this.newChoice = this.newChoice.bind(this)
        this.updateChoice = this.updateChoice.bind(this)
        this.deleteChoice = this.deleteChoice.bind(this)
        this.changeFormula = this.changeFormula.bind(this)
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        this.setState({
            terms: nextProps.terms || [],
            hasCalculator: nextProps.hasCalculator || false,
        })
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        }, () => {
            this.partChanged()
        })
    }

    getCurrentPartObject() {
        return {
            id: this.state.id,
            type: this.state.type,
            name: this.state.name,
            required: this.state.required,
            sequence: this.state.sequence,
            choices: this.state.choices,
        }
    }

    partChanged() {
        this.onChange(this.getCurrentPartObject(), this.state.formula)
    }

    deletePart(event) {
        event.preventDefault()
        this.onDelete(this.getCurrentPartObject())
    }

    newChoice(event) {
        event.preventDefault()
        this.onNewChoice(this.getCurrentPartObject())
    }

    deleteChoice(choice) {
        this.setState({
            choices: this.state.choices.filter(c => c.id !== choice.id)
        }, () => {
            this.partChanged()
        })
    }

    updateChoice(choice) {
        this.setState({
            choices: this.state.choices.map(c => {
                if (c.id === choice.id) {
                    return choice
                } else {
                    return c
                }
            })
        }, () => {
            this.partChanged()
        })
    }

    changeFormula(formula) {
        this.setState({
            formula: formula
        }, () => {
            this.partChanged()
        })
    }

    render() {
        const choices = this.state.choices.map(c => {
            return <AssemblyChoiceEditForm
                choice={c}
                key={c.id}
                onChange={this.updateChoice}
                onDelete={this.deleteChoice}
            />
        })
        let formula = ''
        if (this.state.hasCalculator) {
            formula = <div className="form-group">
                    <CalculatorFormulaForm
                    value={this.state.formula}
                    terms={this.state.terms}
                    onChange={this.changeFormula}
                />
            </div>
        }

        return (
            <div className="mb-2 bg-clean rounded p-3">
                <div className="form-group">
                    <label htmlFor={'name_' + this.state.id}>
                        <FormattedMessage
                            id="product.assembly.form.edit.part_name_label"
                            defaultMessage="Part name"
                        />
                    </label>
                    <input className="form-control"
                           name="name"
                           value={this.state.name}
                           id={'name_' + this.state.id}
                           aria-describedby="nameHelp"
                           placeholder="Part name"
                           onChange={this.handleFormChange}
                    />
                </div>
                <div className="form-group">
                    <div className="custom-control custom-checkbox mr-sm-2">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id={'required_' + this.state.id}
                            name="required"
                            value={this.state.required}
                            checked={this.state.required}
                            onChange={this.handleFormChange}
                        />
                        <label className="custom-control-label" htmlFor={'required_' + this.state.id}>
                            <FormattedMessage
                                id="product.assembly.form.edit.required_label"
                                defaultMessage="Required"
                            />
                        </label>
                    </div>
                </div>
                {formula}
                <div className="row">
                    <h6 className="px-3">
                        <u>
                            <FormattedMessage
                                id="product.assembly.form.edit.choices_label"
                                defaultMessage="Choices :"
                            />
                        </u>
                    </h6>
                </div>
                {choices}
                <div className="form-group form-row pt-3 mb-0">
                    <div className="col-6">
                        <button className="btn btn-danger btn-sm" onClick={this.deletePart}>
                            <FormattedMessage
                                id="product.assembly.form.edit.delete_part"
                                defaultMessage="Delete part"
                            />
                        </button>
                    </div>
                    <div className="col-6 text-align-right">
                        <button className="btn btn-primary btn-sm" onClick={this.newChoice}>
                            <FormattedMessage
                                id="product.assembly.form.edit.new_choice_btn"
                                defaultMessage="Add a choice"
                            />
                        </button>
                    </div>
                </div>

            </div>
        );
    }
}

export default AssemblyPartEditForm


// WEBPACK FOOTER //
// ./src/product/form/assembly/part.component.jsx